const registerType = [
    { label: 'Inspecting Company', value: 'inspectingcompany' },
    { label: 'Ship Operator', value: 'shipoperator' },
];

export default registerType;
